<template>
	<v-main>
		<v-dialog
			v-model="usageDialog"
			max-width="750"
		>
			<v-card>
				<!-- <v-card-title class="text-h5 grey lighten-2">
					ข้อกำหนดและเงื่อนไขการใช้งาน
				</v-card-title> -->
				<v-toolbar
					color="grey darken-1"
					height="48"
					dark
				>
					<v-toolbar-title>ข้อกำหนดและเงื่อนไขการใช้งาน</v-toolbar-title>
					<v-spacer />
					<v-btn
						icon
						small
						@click="usageDialog = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-card-text>
					<h3 class="mt-6 mb-2">
						ข้อกำหนดและเงื่อนไขการใช้งาน
					</h3>
					<p>
						ข้อกำหนดและเงื่อนไขในการใช้งานฉบับนี้ ("ข้อกำหนดและเงื่อนไขฯ" หรือ "สัญญา") เป็นข้อตกลงระหว่าง The Best Property Agent ("บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด" หรือ "เรา") และท่าน ("ผู้ใช้" หรือ "ท่าน") สัญญาฉบับนี้ได้กำหนดข้อกำหนดและเงื่อนไขทั่วไปสำหรับการใช้งานภายในเว็บไซต์ The Best Property Agent รวมกระทั่งถึงผลิตภัณฑ์หรือบริการ และการเข้าร่วมกิจกรรมที่เกี่ยวข้องกับ The Best Property Agent ใด ๆ ก็ตามของท่าน (เรียกรวมกันว่า "เว็บไซต์" หรือ "บริการ")
					</p>

					<h3 class="mt-6 mb-2">
						บัญชีผู้ใช้และสมาชิก
					</h3>
					<p>
						หากท่านได้ทำการสร้างบัญชีผู้ใช้บนเว็บไซต์ ท่านมีหน้าที่ในการรักษาความปลอดภัยของบัญชีของท่านและท่านต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดขึ้นภายใต้การใช้งานบัญชีหรือการดำเนินการอื่นใดที่เกี่ยวข้องกับบัญชีนั้น เราอาจมีการสังเกตการณ์และตรวจสอบบัญชีใหม่ก่อนที่ท่านจะลงชื่อเข้าใช้และใช้บริการของเรา การให้ข้อมูลติดต่อที่เป็นเท็จไม่ว่าประเภทใดก็ตามอาจส่งผลให้บัญชีของท่านถูกยุติการใช้งาน ท่านต้องแจ้งให้เราทราบทันทีเมื่อบัญชีของท่านถูกนำไปใช้โดยไม่ได้รับอนุญาตหรือเมื่อมีการละเมิดความปลอดภัยอื่น ๆ ทางเราจะไม่ขอรับผิดชอบต่อความเสียหายใด ๆ ที่เกิดขึ้นจากการกระทำหรือการละเว้นการกระทำของท่าน เราอาจทำการระงับ ปิดการใช้งาน หรือลบบัญชีผู้ใช้ของท่าน (หรืออย่างใดอย่างหนึ่ง) หากเราพิจารณาว่าท่านได้ละเมิดข้อกำหนดใด ๆ ของข้อตกลงนี้หรือการกระทำของท่านมีแนวโน้มที่จะทำลายชื่อเสียงและค่าความนิยมของเรา หากเราลบบัญชีของท่านด้วยเหตุผลข้างต้น ท่านจะไม่สามารถลงทะเบียนใหม่เพื่อใช้บริการของเราได้ โดยเราอาจทำการปิดกั้นที่อยู่อีเมลของท่านเพื่อป้องกันการลงทะเบียนอีกครั้ง
					</p>

					<h3 class="mt-6 mb-2">
						เนื้อหาของผู้ใช้งาน
					</h3>
					<p>
						เราไม่ได้เป็นเจ้าของข้อมูลหรือเนื้อหาใด ๆ (“เนื้อหา”) ที่ท่านได้ให้ไว้บนเว็บไซต์เพื่อการใช้งานใช้บริการและกิจกรรมต่างๆ ท่านจะต้องรับผิดชอบต่อความถูกต้อง คุณภาพ ความสมบูรณ์ ความถูกต้องตามกฎหมาย ความน่าเชื่อถือ ความเหมาะสมและความเป็นเจ้าของทรัพย์สินทางปัญญาหรือสิทธิในการใช้เนื้อหาที่นำส่งทั้งหมดแต่เพียงผู้เดียว เราอาจสังเกตการณ์และตรวจสอบเนื้อหาบนเว็บไซต์ที่ท่านนำส่งหรือสร้างขึ้นจากการบริการโดยตัวท่าน การใช้งานเว็บไซต์ โดยท่าน อนุญาตเราในการใช้เนื้อหาที่ท่านสร้างขึ้นหรือจัดเก็บไว้ในบัญชีผู้ใช้ของท่านเพื่อการตลาดหรือวัตถุประสงค์อื่นใดที่มีคล้ายกัน เราขอสงวนสิทธิ์ในการปฏิเสธหรือลบเนื้อหาใด ๆ ที่ละเมิดนโยบายของเรา ไม่เหมาะสม หรือเป็นอันตรายในทางใดทางหนึ่งต่อข้อกำหนดและเงื่อนไขตามดุลยพินิจของเรา
					</p>

					<h3 class="mt-6 mb-2">
						เนื้อหาและการโพสต์
					</h3>
					<p>
						ท่านไม่สามารถแก้ไข พิมพ์ หรือทำสำเนาในส่วนใดของเว็บไซต์ การนำบางส่วนของเว็บไซต์ ไปรวมเข้ากับงานอื่น ไม่ว่าจะเป็นในรูปแบบสื่อพิมพ์หรืออิเล็กทรอนิกส์หรือรูปแบบอื่นใดก็ตาม หรือนำบางส่วนของเว็บไซต์ ไปรวมไว้ในเว็บไซต์อื่นในรูปแบบการฝังไว้ในเว็บไซต์ (embedding) แบ่งไว้เป็นส่วนในหน้าเว็บไซต์ (framing) หรือวิธีการอื่นใดโดยไม่ได้รับอนุญาตที่ชัดแจ้งจากบริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด จะถือเป็นสิ่งต้องห้ามในการกระทำ
					</p>
					<p>
						ท่านจะต้องไม่ทำการอัปโหลดเนื้อหาที่เป็นการหมิ่นประมาท ฉ้อฉล อนาจาร หมิ่นประมาท คุกคาม ล่วงล้ำในสิทธิความเป็นส่วนตัวของผู้อื่น หรือทางอื่นใดที่ไม่ชอบด้วยกฎหมาย ท่านจะต้องไม่ทำการละเมิดในทรัพย์สินทางปัญญาของบุคคลหรือบริษัทอื่น ท่านจะต้องไม่ทำการอัปโหลดไวรัสคอมพิวเตอร์หรือโค้ดอื่นใดที่จัดทำขึ้นเพื่อทำให้เกิดความขัดข้อง เสียหาย หรือจำกัดระบบการทำงานของซอฟต์แวร์หรือฮาร์ดแวร์ของคอมพิวเตอร์ ในการนำส่งหรืออัปโหลดไฟล์บนเว็บไซต์ถือว่าท่านได้ยินยอมให้บริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด ในการนำออกซึ่งไฟล์ใด ๆ ในเวลาใด ๆ ก็ได้
					</p>

					<h3 class="mt-6 mb-2">
						กิจกรรมการแนะนำนายหน้ารายใหม่ (Referral Program)
					</h3>
					<p>
						ทางเรามีการจัดกิจกรรมการแนะนำเพื่อรับสมัครนายหน้ารายใหม่ (Referral Program) ขึ้นเพื่อให้ผู้ที่สนใจในกิจกรรมการแนะนำของเรา ได้สมัครลงทะเบียนเข้าร่วมฟัง Instant Intro และกิจกรรมอื่นๆ โดยการนำรหัสผู้แนะนำที่ได้รับจากกิจกรรม ไปให้ผู้ที่สนใจในกิจกรรมที่ยังไม่เคยมีการสั่งซื้อสินค้าหรือบริการกับเรามาก่อน ทำการกรอกข้อมูลส่วนตัว พร้อมอ้างอิงรหัสผู้แนะนำในขั้นตอนการลงทะเบียน เพื่อเข้าร่วมกิจกรรมต่างๆ
					</p>

					<h3 class="mt-6 mb-2">
						การชำระเงินค่าลงทะเบียนและกิจกรรม
					</h3>
					<p>
						เราขอสงวนสิทธิ์ในการเปลี่ยนแปลงราคาผลิตภัณฑ์ บริการ และกิจกรรมที่เกี่ยวข้องกับ The Best Property Agent ได้ตลอดเวลา และเราขอสงวนสิทธิ์ในการปฏิเสธคำสั่งซื้อใด ๆ ที่ท่านสั่งซื้อกับเรา โดยเราอาจจำกัดคำสั่งซื้อตามดุลยพินิจของเรา
					</p>
					<p>
						ในกรณีที่เราทำการเปลี่ยนแปลงหรือยกเลิกคำสั่งซื้อ เราจะแจ้งให้ท่านทราบโดยติดต่อไปทางอีเมล  หรือหมายเลขโทรศัพท์ที่ท่านได้ให้ไว้ในขณะที่ทำการสั่งซื้อ
					</p>
					<p>
						The Best Property Agent นำเสนอผลิตภัณฑ์ บริการ และกิจกรรมที่เกี่ยวข้อง เมื่อเราได้รับคำสั่งซื้อและการชำระค่าสินค้า/บริการของท่าน ผ่านการตรวจสอบเรียบร้อยแล้ว เราจะให้สิทธิในการเข้าถึงผลิตภัณฑ์ บริการ และกิจกรรมที่เกี่ยวข้อง ที่ซื้อแก่ท่านโดยเร็วที่สุด
					</p>

					<h3 class="mt-6 mb-2">
						เชื่อมต่อไปยังเว็บไซต์อื่น
					</h3>
					<p>
						แม้ว่าเว็บไซต์นี้อาจมีการเชื่อมต่อไปยังเว็บไซต์อื่น เราไม่ได้อนุมัติโดยเป็นนัยยะ ร่วมกัน สนับสนุน ช่วยเหลือ หรือเป็นเครือเดียวกันกับเว็บไซต์อื่นที่ได้มีการเชื่อมต่อไม่ว่าจะทางตรงหรืออ้อม เว้นเสียแต่ได้กำหนดไว้เป็นการเฉพาะไว้ในที่นี้ เราไม่มีหน้าที่ในการตรวจสอบหรือประเมิน และเราไม่ขอรับรองในข้อเสนอของธุรกิจหรือบุคคลใด ๆ หรือเนื้อหาในเว็บไซต์นั้น เราไม่รับผิดชอบหรือรับผิดใด ๆ ต่อการกระทำ ผลิตภัณฑ์ บริการและเนื้อหาของบุคคลอื่นๆ
					</p>

					<h3 class="mt-6 mb-2">
						ข้อห้ามในการใช้งาน
					</h3>
					<p>
						นอกจากข้อตกลงอื่นที่ได้กำหนดไว้ภายใต้สัญญา ห้ามมิให้ท่านใช้งานเว็บไซต์ หรือจัดทำเนื้อหาในลักษณะดังนี้ (ก) เพื่อวัตถุประสงค์ที่มิชอบด้วยกฎหมาย (ข) ชักชวนหรือสนับสนุนผู้อื่นให้ดำเนินการหรือมีส่วนร่วมในการกระทำที่ผิดกฎหมาย (ค) ละเมิดกฎระเบียบ ข้อบังคับ กฎหมายหรือข้อบัญญัติท้องถิ่นระหว่างประเทศ รัฐบาลกลาง จังหวัดหรือรัฐ (ง) กระทำการละเมิดสิทธิในทรัพย์สินทางปัญญาใด ๆ ของเราหรือสิทธิในทรัพย์สินทางปัญญาของผู้อื่น (จ) คุกคาม ล่วงละเมิด ดูหมิ่น ทำร้าย ทำให้เสียชื่อเสียง ใส่ร้าย ข่มขู่หรือเลือกปฏิบัติตามเพศ รสนิยมทางเพศศาสนา ชาติพันธุ์ เชื้อชาติ อายุ ชาติกำเนิดหรือความทุพพลภาพ (ฉ) นำส่งข้อมูลเท็จหรือบิดเบือนข้อมูล (ช) เพื่ออัปโหลดหรือส่งไวรัสหรือรหัสที่เป็นอันตรายประเภทอื่นที่จะหรืออาจใช้ในลักษณะใด ๆ ที่จะส่งผลกระทบต่อการทำงานหรือการทำงานของบริการหรือเว็บไซต์ที่เกี่ยวข้อง เว็บไซต์อื่น ๆ หรืออินเทอร์เน็ต (ซ) เก็บรวบรวมหรือติดตามข้อมูลส่วนบุคคลของผู้อื่น (ฌ) การส่งข้อความที่ผู้รับไม่ได้ร้องขอ (spam) การหลอกลวงโดยใช้อีเมลหรือหน้าเว็บไซต์ปลอม (phish) การเปลี่ยนแปลงเส้นทางการเข้าชมเว็บไซต์ไปยังเว็บไซต์ปลอมเพื่อโจรกรรมข้อมูลผู้ใช้ (pharm) แอบอ้างเป็นผู้มีสิทธิเข้าถึงข้อมูล (pretext) การใช้โปรแกรมเก็บรวบรวมข้อมูลบนเว็บไซต์ (spider) การเก็บรวบรวมข้อมูลเว็บไซต์ (crawl) หรือการดึงข้อมูลจากเว็บไซต์อื่น ๆ เพื่อนำมาใช้งาน (scrape) (ญ) เพื่อวัตถุประสงค์ในทางอนาจารหรือผิดศีลธรรม หรือ (ฎ) เพื่อแทรกแซงหรือหลีกเลี่ยงคุณลักษณะทางด้านความปลอดภัยของบริการหรือเว็บไซต์ที่เกี่ยวข้อง เว็บไซต์อื่น ๆ หรืออินเทอร์เน็ต เราขอสงวนสิทธิ์ในการยกเลิกการใช้บริการหรือใช้เว็บไซต์ใดๆ ของท่านจากการฝ่าฝืนการใช้งานที่ต้องห้าม
					</p>

					<h3 class="mt-6 mb-2">
						สิทธิในทรัพย์สินทางปัญญา
					</h3>
					<p>
						สัญญานี้จะไม่เป็นการโอนสิทธิในทรัพย์สินทางปัญญาใด ๆ ที่เป็นของ The Best Property Agent จำกัด โดยสิทธิ กรรมสิทธิ์ และผลประโยชน์ทั้งหมดของทรัพย์สินดังกล่าว ซึ่งไม่จำกัดไว้เพียงลิขสิทธิ์ สิทธิบัตร สิทธิในความลับทางการค้าและสิทธิในทรัพย์สินทางปัญญาอื่นใดจะยังคงอยู่ (ในระหว่างคู่สัญญา) กับ บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด แต่เพียงผู้เดียว เครื่องหมายทางการค้า เครื่องหมายบริการ กราฟิก และโลโก้ทั้งหมดที่ถูกใช้เกี่ยวกับเว็บไซต์หรือบริการของเราหรือเว็บไซต์ที่เป็นกิจกรรมเกี่ยวข้องกับ The Best Property Agent เป็นเครื่องหมายทางการค้าหรือเครื่องหมายทางการค้าที่ได้จดทะเบียนของ บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด เท่านั้น การใช้งานเว็บไซต์ บริการและกิจกรรมต่างๆ ของท่านจะไม่เป็นการให้สิทธิหรืออนุญาตให้ท่านทำซ้ำ ดัดแปลง เผยแพร่หรือใช้เครื่องหมายการค้าใดของบริษัท เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด
					</p>

					<h3 class="mt-6 mb-2">
						การชดใช้ค่าเสียหาย
					</h3>
					<p>
						ท่านตกลงที่จะชดใช้ค่าเสียหายให้แก่ บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด กรรมการ เจ้าหน้าที่ พนักงาน และตัวแทน ต่อความรับผิด ความสูญเสีย ความเสียหายหรือค่าใช้จ่าย รวมถึงค่าทนายความที่เหมาะสม ที่เกี่ยวเนื่องหรือเกิดขึ้นจากข้อกล่าวหา ข้อเรียกร้อง การกระทำ ข้อพิพาท หรือการดำเนินการข้อพิพาทหรือข้อเรียกร้องใด ๆ ของบุคคลที่สาม อันเป็นผลมาจากหรือเกี่ยวกับเนื้อหาของท่าน การใช้งานหรือบริการโดยท่าน รวมถึงการกระทำอันมิชอบโดยเจตนาใด ๆ ของท่าน
					</p>

					<h3 class="mt-6 mb-2">
						การระงับข้อพิพาท
					</h3>
					<p>
						การเริ่มทำ ตีความ และการปฏิบัติภายใต้สัญญาฉบับนี้และข้อพิพาทที่ได้เกิดขึ้นจากสัญญาฉบับนี้จะต้องตกอยู่ภายใต้กฎหมาย วิธีพิจารณากฎหมายแห่งราชอาณาจักรไทย โดยไม่ต้องคำนึงถึงความขัดแย้งทางกฎหมายแห่งราชอาณาจักรไทยตามที่สามารถกระทำได้ เขตอำนาจศาล และสถานที่สำหรับการดำเนินการทางกฎหมายที่เกี่ยวข้องกับประเด็นข้อพิพาทในเรื่องของสัญญานี้ ให้อยู่ในเขตอำนาจศาลของราชอาณาจักรไทย และท่านจะนำข้อพิพาทเข้าสู่เขตอำนาจศาลดังกล่าว
					</p>

					<h3 class="mt-6 mb-2">
						การเปลี่ยนแปลงและการแก้ไข
					</h3>
					<p>
						เราขอสงวนสิทธิ์ในการแก้ไขสัญญาฉบับนี้หรือนโยบายที่เกี่ยวข้องกับเว็บไซต์ หรือบริการในเวลาใดก็ได้ โดยจะมีผลทันทีเมื่อได้ทำการเผยแพร่สัญญาฉบับล่าสุดลงบนเว็บไซต์ โดยเราจะทำการระบุวันที่มีการแก้ไขลงไว้ข้างใต้ของสัญญา การเข้าใช้งานเว็บไซต์ หลังจากที่มีการแก้ไขดังกล่าวจะถือเป็นการที่ท่านได้ยินยอมในการแก้ไขนั้น ๆ
					</p>

					<h3 class="mt-6 mb-2">
						การยอมรับในข้อตกลง
					</h3>
					<p>
						ท่านยอมรับและรับทราบว่าท่านได้อ่านสัญญาฉบับนี้และยินยอมในข้อตกลงและเงื่อนไขทั้งหมดดังกล่าว ในการใช้งานเว็บไซต์ หรือบริการย่อมถือว่าท่านได้ยินยอมที่จะผูกพันกับสัญญาฉบับนี้ หากท่านไม่ยินยอมในข้อตกลงของสัญญาฉบับนี้ ท่านจะไม่มีสิทธิในการใช้งานหรือเข้าถึงเว็บไซต์ บริการ และกิจกรรมดังกล่าว
					</p>

					<h3 class="mt-6 mb-2">
						ข้อจำกัดความรับผิด
					</h3>
					<p>
						ตามขอบเขตสูงสุดของกฎหมายที่อนุญาตบังคับใช้ได้ ไม่ว่าในกรณีใดก็ตาม บริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด เจ้าหน้าที่ กรรมการ พนักงาน ตัวแทน หรือผู้ได้รับอนุญาตของบริษัท เดอะเบสท์ พร็อพเพอร์ตี้ เอเจนท์ จำกัด จะไม่รับผิดชอบต่อบุคคลใด ๆ สำหรับเรื่องต่อไปนี้ (ก) ความเสียหายทางอ้อม ความเสียหายโดยไม่ตั้งใจ ความเสียหายพิเศษ ความเสียหายในเชิงลงโทษ ความเสียหายในการชดใช้ หรือความเสียหายที่เป็นผลสืบเนื่อง (ซึ่งรวมถึงแต่ไม่จำกัดเพียง ความเสียหายจากผลกำไร รายได้ การค้าขาย ค่าความนิยม การใช้เนื้อหา ผลกระทบต่อธุรกิจ ธุรกิจหยุดชะงัก การสูญเสียเงินเก็บที่คา ดการณ์เอาไว้ การสูญเสียโอกาสทางธุรกิจ)
					</p>

					<h3 class="mt-6 mb-2">
						ติดต่อเรา
					</h3>
					<p>
						หากท่านต้องการติดต่อเราเพื่อทำความเข้าใจเพิ่มเติมเกี่ยวกับสัญญาฉบับนี้ หรือมีข้อสงสัยอื่นใดที่เกี่ยวข้อง ท่านสามารถติดต่อเราได้ทาง Email :

						<a
							style="color: red; text-decoration: none;"
							href="mailto:thebestproperty99@gmail.com"
							title="ติดต่อ The Best Property ผ่าน email"
							target="_blank"
						>
							thebestproperty99@gmail.com
						</a>
					</p>

					<p>
						เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อวันที่ 23 กุมภาพันธ์ พ.ศ. 2567
					</p>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="privacyDialog"
			max-width="750"
		>
			<v-card>
				<!-- <v-card-title class="text-h5 grey lighten-2">
					ข้อกำหนดและเงื่อนไขการใช้งาน
				</v-card-title> -->
				<v-toolbar
					color="grey darken-1"
					height="48"
					dark
				>
					<v-toolbar-title>นโยบายความเป็นส่วนตัว</v-toolbar-title>
					<v-spacer />
					<v-btn
						icon
						small
						@click="privacyDialog = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-toolbar>

				<v-card-text>
					<h3 class="mt-6 mb-2">
						นโยบายความเป็นส่วนตัว
					</h3>
					<p>
						โปรดอ่านนโยบายความเป็นส่วนตัวนี้อย่างรอบคอบก่อนใช้งานระบบนี้
					</p>

					<h3 class="mt-6 mb-2">
						การเก็บรวบรวมข้อมูลส่วนบุคคล
					</h3>
					<p>
						1. เพื่อความสะดวกในการให้บริการแก่ผู้ใช้บริการทุกท่านที่เข้ามายังเว็บไซต์ The Best Property Agent ในกรณีที่ท่านสมัครลงทะเบียน (Sign up) เพื่อเข้าชม Instant Intro หรือเพื่อใช้บริการอย่างใดอย่างหนึ่ง ทางเว็บไซต์จึงได้จัดเก็บรวบรวมข้อมูลส่วนบุคคลของท่านไว้ เช่น ชื่อ นามสกุล ชื่อเล่น จังหวัดที่อยู่ปัจจุบัน หมายเลขโทรศัพท์ หรือเบอร์ติดต่อ Facebook อีเมล์แอดเดรส Line ID พร้อมทั้งช่องทางการติดต่อกลับ เป็นต้น พร้อมทั้งThe Best Property Agent จะเก็บรวบรวมข้อมูลส่วนบุคคลของท่านเพิ่มเติม ได้แก่ ระยะเวลาในการลงทะเบียนจนถึงเสร็จสิ้นขั้นตอน โดยข้อมูลเหล่านี้ ผู้ที่แนะนำท่านจะได้รับทราบข้อมูลเหล่านี้ เป็นต้น
					</p>
					<p>
						2. นอกจากนั้น เพื่อสำรวจความนิยมในการใช้บริการ อันจะเป็นประโยชน์ในการนำสถิติไปใช้ในการปรับปรุงคุณภาพในการให้บริการ The Best Property Agent จึงจำเป็นต้องจัดเก็บรวบรวมข้อมูลของท่านบางอย่างเพิ่มเติมด้วย ได้แก่ บันทึกหน้าเว็บ (web page) ของเว็บไซต์ที่ผู้ใช้เยี่ยมชม เวลาที่เยี่ยมชมเว็บไซต์ (Access Times) และเว็บไซต์ที่ผู้ใช้บริการเข้าถึงก่อนหน้านั้น (Referring Website Addresses)
					</p>
					<p>
						3. The Best Property Agent ขอแนะนำให้ท่านตรวจสอบนโยบายความเป็นส่วนตัวของเว็บไซต์อื่นที่เชื่อมโยงจากเว็บไซต์นี้ เพื่อจะได้ทราบและเข้าใจว่าเว็บไซต์ดังกล่าวเก็บรวบรวม ใช้ หรือดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่านอย่างไร ทั้งนี้ The Best Property Agent ไม่สามารถรองรับข้อความ หรือรับรองการดำเนินการตามที่ได้มีการประกาศไว้ในเว็บไซต์ดังกล่าวได้ และไม่ขอรับผิดชอบใดๆ หากเว็บไซต์เหล่านั้นไม่ได้ปฏิบัติการหรือดำเนินการใดๆ ตามนโยบายความเป็นส่วนตัวที่เว็บไซต์ดังกล่าวได้ประกาศไว้
					</p>

					<h3 class="mt-6 mb-2">
						การใช้ข้อมูลส่วนตัว
					</h3>
					<p>
						1. The Best Property Agent จะใช้ข้อมูลส่วนบุคคลของท่านเพียงเท่าที่จำเป็น เช่น ชื่อ นามสกุล เฟซบุ๊ก หมายเลขโทรศัพท์ หรือเบอร์ติดต่อ อีเมล์แอดเดรส Line ID เพื่อใช้ในการติดต่อ ให้บริการ ประชาสัมพันธ์ หรือให้ข้อมูลข่าวสารต่างๆ รวมทั้งสำรวจความคิดเห็นของท่านในกิจการหรือกิจกรรมของ The Best Property Agent เท่านั้น
					</p>
					<p>
						2. The Best Property Agent ขอรับรองว่าจะไม่นำข้อมูลส่วนบุคคลของท่านที่ The Best Property Agent ได้เก็บรวบรวมไว้ ไปขายหรือเผยแพร่ให้กับบุคคลภายนอกโดยเด็ดขาด เว้นแต่จะได้รับอนุญาตจากท่านเท่านั้น
					</p>
					<p>
						3. ในกรณีที่ The Best Property Agent ได้ว่าจ้างหน่วยงานอื่นเพื่อให้ดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่าน เช่น การวิเคราะห์เชิงสถิติในกิจการหรือกิจกรรมของ The Best Property Agent เป็นต้น The Best Property Agent จะกำหนดให้หน่วยงานที่ได้ว่าจ้างให้ดำเนินการดังกล่าว เก็บรักษาความลับและความปลอดภัยของข้อมูลส่วนบุคคลของท่าน และกำหนดข้อห้ามมิให้มีการนำข้อมูลส่วนบุคคลดังกล่าวไปใช้นอกเหนือจากกิจกรรมหรือกิจการของ The Best Property Agent
					</p>

					<h3 class="mt-6 mb-2">
						สิทธิในการควบคุมข้อมูลส่วนบุคคลของท่าน
					</h3>
					<p>
						เพื่อประโยชน์ในการรักษาความเป็นส่วนตัวของท่าน ท่านมีสิทธิที่จะให้มีการใช้หรือแชร์ข้อมูลส่วนบุคคลของท่าน หรืออาจเลือกที่จะไม่รับข้อมูลหรือสื่อสารทางการตลาดใดๆจาก The Best Property Agent ก็ได้ โดยเพียงแต่ท่านแจ้งความจำนงดังกล่าวเพื่อแจ้งให้ The Best Property Agent ทราบได้ในทันที
					</p>

					<h3 class="mt-6 mb-2">
						การรักษาความปลอดภัยสำหรับข้อมูลส่วนบุคคล
					</h3>
					<p>
						เพื่อประโยชน์ในการรักษาความลับและความปลอดภัยสำหรับข้อมูลส่วนบุคคลของท่าน The Best Property Agent จึงได้กำหนดระเบียบภายในหน่วยงานเพื่อกำหนดสิทธิในการเข้าถึงหรือใช้ข้อมูลส่วนบุคคลของท่าน และเพื่อรักษาความลับและความปลอดภัยของข้อมูลบางอย่างที่มีความสำคัญอย่างยิ่ง เช่น ข้อมูลการติดต่อส่วนตัว เป็นต้น The Best Property Agent จึงได้จัดให้มีช่องทางการสื่อสารแบบปลอดภัยสำหรับข้อมูลดังกล่าวด้วยการเข้ารหัสลับข้อมูลดังกล่าว เช่น จัดให้มีการใช้ Secure Socket Layer (SSL) protocol เป็นต้น หรืออาจกระทำผ่านหน่วยงานกลางที่มีมาตราฐานความปลอดภัยในระดับเทียบเท่ากัน
					</p>

					<h3 class="mt-6 mb-2">
						การใช้คุกกี้ (Cookies)
					</h3>
					<p>
						“คุกกี้” คือ ข้อมูลที่ The Best Property Agent ส่งไปยังโปรแกรมค้นผ่านเว็บไซต์ (Web browser) ของผู้ใช้บริการ และเมื่อมีการติดตั้งข้อมูลดังกล่าวไว้ในระบบของท่านแล้ว หากมีการใช้ “คุกกี้” ก็จะทำให้เว็บไซต์ The Best Property Agent สามารถบันทึกหรือจดจำข้อมูลของผู้ใช้บริการไว้ จนกว่าผู้ใช้บริการจะออกจากโปรแกรมค้นผ่านเว็บไซต์ หรือจนกว่าผู้ใช้บริการจะทำการลบ “คุกกี้” นั้นเสีย หรือไม่อนุญาตให้ “คุกกี้” นั้นทำงานต่อไป
					</p>
					<p>
						หากท่านเลือกใช้ “คุกกี้” แล้ว ท่านจะได้รับประสบการณ์การใช้งานที่ดียิ่งขึ้น รวมถึงนำเสนอเนื้อหา และประชาสัมพันธ์สิทธิประโยชน์ที่ตรงกับความต้องการพร้อมได้รับความสะดวกสบายในการท่องเว็บไซต์มากขึ้น เพราะ “คุกกี้” จะช่วยจดจำเว็บไซต์ที่ท่านเข้าเยี่ยมชม
					</p>
					<p>
						ทั้งนี้ The Best Property Agent จะนำข้อมูลที่ “คุกกี้” ได้บันทึกหรือเก็บรวบรวมไว้ไปใช้ในการวิเคราะห์เชิงสถิติ หรือในกิจกรรมอื่นของ The Best Property Agent เพื่อปรับปรุงคุณภาพการให้บริการของ The Best Property Agent ต่อไป
					</p>

					<h3 class="mt-6 mb-2">
						การปรับปรุงนโยบายความเป็นส่วนตัว
					</h3>
					<p>
						The Best Property Agent อาจทำการปรับปรุงหรือแก้ไขนโยบายความเป็นส่วนตัวโดยไม่ได้แจ้งให้ท่านทราบล่วงหน้า ทั้งนี้ เพื่อความเหมาะสมและมีประสิทธิภาพในการให้บริการ ดังนี้ The Best Property Agent จึงขอแนะนำให้ผู้ใช้บริการอ่านนโยบายความเป็นส่วนตัวทุกครั้งที่แวะชม หรือเยี่ยมชม หรือมีการใช้บริการจากเว็บไซต์ The Best Property Agent
					</p>

					<h3 class="mt-6 mb-2">
						การปฏิบัติตามนโยบายความเป็นส่วนตัวและการติดต่อกับ The Best Property Agent
					</h3>
					<p>
						ในกรณีที่ท่านมีข้อสงสัย ข้อเสนอแนะ หรือข้อติชมใดๆ เกี่ยวกับนโยบายความเป็นส่วนตัว หรือการปฏิบัติตามนโยบายความเป็นส่วนตัวฉบับนี้ The Best Property Agent ยินดีที่จะตอบข้อสงสัย รับฟังข้อเสนอแนะ และคำติชมทั้งหลาย อันจะเป็นประโยชน์ต่อการปรับปรุงการให้บริการของ The Best Property Agent ต่อไป โดยท่านสามารถติดต่อกับ The Best Property Agent ได้ที่ Line :
						<a
							style="color: green; text-decoration: none;"
							href="https://line.me/ti/p/@Thebestagent"
							title="ไลท์แชทกับ The Best Property ไอดี @Thebestagent"
							target="_blank"
						>
							@Thebestagent
						</a>
					</p>

					<h3 class="mt-6 mb-2">
						ลบบัญชีการลงทะเบียนเพื่อเข้าชม Instant Intro หรือเพื่อใช้บริการอย่างใดอย่างหนึ่งของ The Best Property Agent
					</h3>
					<p>
						คุณลบบัญชีและข้อมูลส่วนตัวของคุณบน The Best Property Agent ได้ทุกเมื่อ แต่หากเปลี่ยนใจ จะไม่สามารถกู้คืนได้
					</p>
					<p>
						ขั้นตอน การลบบัญชีการลงทะเบียน
					</p>
					<p>
						ติดต่อช่องทาง Line :
						<a
							style="color: green; text-decoration: none;"
							href="https://line.me/ti/p/@Thebestagent"
							title="ไลท์แชทกับ The Best Property ไอดี @Thebestagent"
							target="_blank"
						>
							@Thebestagent
						</a>
						"เพื่อแจ้งรายละเอียด" กับเจ้าหน้าที่
					</p>
				</v-card-text>
			</v-card>
		</v-dialog>

		<div
			ref="topPage"
			class="bgGray py-5"
		>
			<div
				v-if="regStep === 1"
				class="text-center"
				style="font-size: 2em; color: #BDBDBD;"
			>
				<b v-if="step1Selected">
					ยืนยันข้อมูล
				</b>
				<b v-else>เริ่มต้น</b>
			</div>
			<div
				v-else-if="regStep === 2"
				class="text-center"
				style="font-size: 2em; color: #BDBDBD;"
			>
				<b>กรอกข้อมูลลงทะเบียน</b>
			</div>
			<div
				v-else-if="regStep === 3"
				class="text-center"
				style="font-size: 2em; color: #BDBDBD;"
			>
				<b>ยินดีต้อนรับสู่</b><br>
				The Best Property Agent<br>
				<b class="red--text">INSTANT INTRO</b>
			</div>
			<div
				v-else
				class="text-center"
				style="font-size: 2em; color: #BDBDBD;"
			>
				<b>&nbsp;</b>
			</div>
		</div>
		<v-container>
			<v-row>
				<v-col
					md="10"
					lg="8"
					xl="6"
					offset-md="1"
					offset-lg="2"
					offset-xl="3"
				>
					<client-only>
						<v-card
							v-if="!urlValid"
							class="mt-6 px-8 py-4 text-center"
							:flat="loading"
							:color="loading ? 'rgba(0,0,0,0)' : ''"
							dark
						>
							<v-progress-circular
								v-if="loading"
								:size="50"
								:width="10"
								color="red"
								class="mx-auto"
								indeterminate
							/>

							<h2 v-else>
								URL นี้ไม่สามารถใช้งานได้ กรุณาติดต่อผู้ดูแลระบบ
							</h2>
						</v-card>

						<v-stepper
							v-else
							v-model="regStep"
							class="black--text"
							dark
							alt-labels
						>
							<v-stepper-header>
								<v-stepper-step
									:complete="regStep > 1"
									step="1"
								>
									<div class="text-center">
										เริ่มต้น
									</div>
								</v-stepper-step>
								<v-divider />
								<v-stepper-step
									:complete="regStep > 2"
									step="2"
								>
									<div class="text-center">
										กรอกข้อมูลลงทะเบียน
									</div>
									<!-- <small>(*) ข้อมูลที่จำเป็นต้องกรอก</small> -->
								</v-stepper-step>
								<v-divider />
								<v-stepper-step
									:complete="regStep > 3"
									step="3"
								>
									รับชม Video
								</v-stepper-step>
								<v-divider />
								<v-stepper-step
									:complete="regStep > 4"
									step="4"
								>
									เลือกหลักสูตร
								</v-stepper-step>
							</v-stepper-header>

							<v-stepper-items>
								<v-stepper-content
									step="1"
									:class="{'pa-0 white': !step1Selected}"
								>
									<div v-if="!step1Selected">
										<img
											:src="loading ? '/lazy_2.jpg' : (staInfo.banner_url || '/images/ContentSTA-01.jpg')"
											alt="start up agent"
											width="100%"
											:styles="`${loading || !staInfo ? 'margin-top: -50%' : ''}`"
										>

										<v-row
											no-gutters
											class="px-sm-4 px-md-8"
										>
											<v-col
												cols="5"
												sm="4"
												lg="3"
											>
												<img
													src="/images/TB1.png"
													alt="หลักสูตร START UP AGENT หรือ STA"
													width="110%"
													class="mb-n1 mt-1 mt-sm-n8 mt-md-n12 d-sm-nones"
												>
											</v-col>

											<v-col
												cols="7"
												sm="8"
												lg="9"
												class="pt-3 pr-3"
											>
												<b>หลักสูตร START UP AGENT</b>
												<p class="mb-2">
													“ก้าวแรก” ของการเป็นนายหน้าอสังหาฯ จากจุดเริ่มต้นสู่การเป็นนายหน้ามืออาชีพ
													<span class="d-none d-sm-inline">
														ด้วยกระแสตอบรับเป็นอย่างดีในทุก ๆ รอบที่จัดขึ้น ทำให้ปัจจุบันมีผู้เข้ารับการสัมมนา มากกว่า 1,000 คนทั่วประเทศไทย
													</span>
												</p>
												<p class="mb-0">
													<span class="d-none d-sm-inline">
														พร้อมนำคุณเข้าสู่ ธุรกิจนายหน้าอสังหาฯ อย่างเต็มตัว
													</span>
													ด้วยระบบ
													<b>SMART AGENT SYSTEM</b>
													ยกระดับประสบการณ์เพิ่มความเป็นมือโปร..ให้กับคุณ
												</p>
											</v-col>
										</v-row>

										<h2 class="bgRed white--text text-center pa-3 d-none d-md-block">
											พร้อมอัปเกรด”คุณ”เป็นนายหน้ามืออาชีพ<br> มีทรัพย์ให้ขายทันที มากกว่า 20,000 รายการ
										</h2>
										<h3 class="bgRed white--text text-center pa-3 d-none d-sm-block d-md-none">
											พร้อมอัปเกรด”คุณ”เป็นนายหน้ามืออาชีพ<br> มีทรัพย์ให้ขายทันที มากกว่า 20,000 รายการ
										</h3>
										<h4 class="bgRed white--text text-center pa-3 d-sm-none">
											พร้อมอัปเกรด”คุณ”เป็นนายหน้ามืออาชีพ<br> มีทรัพย์ให้ขายทันที มากกว่า 20,000 รายการ
										</h4>

										<h2 class="text-center pa-3 d-none d-md-block">
											คอร์ส START UP AGENT<br>
											เริ่มต้นการเป็นนายหน้าอสังหาฯ (แบบมืออาชีพ)
										</h2>
										<h3 class="text-center pa-3 d-none d-sm-block d-md-none">
											คอร์ส START UP AGENT<br>
											เริ่มต้นการเป็นนายหน้าอสังหาฯ (แบบมืออาชีพ)
										</h3>
										<h4 class="text-center pa-3 d-sm-none">
											คอร์ส START UP AGENT<br>
											เริ่มต้นการเป็นนายหน้าอสังหาฯ (แบบมืออาชีพ)
										</h4>

										<div
											class="sta-ul pr-3 px-sm-8 px-md-12"
											style="font-size: 1.1em;"
										>
											<ul class="pl-0 pl-sm-3 d-none d-sm-block">
												<li>คอร์สเริ่มต้นอาชีพนายหน้า คอร์สพื้นฐานนายหน้าอสังหาฯ ไม่มีความรู้เรื่องนายหน้ามาก่อนก็สามารถเรียนได้</li>
												<li>สอนจริงทุกขั้นตอน เนื้อหาเรียนรู้อย่างมืออาชีพเห็นภาพและเข้าใจการทำงานอย่างชัดเจน</li>
												<li>นายหน้ามืออาชีพ ทำงานกันอย่างไร? ให้ความรู้แนะนำวิธีการจนถึงบอกเคล็ดลับการทำงานเส้นทางสู่นายหน้ามืออาชีพ พบได้ในคอร์สนี้ กับคอร์ส STA 1 วันเต็ม</li>
												<li>เรียนคอร์ส STA จบแล้ว สามารถนำไปปฏิบัติได้จริง สอนตั้งแต่เริ่มต้นหาทรัพย์ ไปจนถึงการโอนกรรมสิทธิ ไม่ต้องลองผิดลองถูก..อีกต่อไป</li>
												<li>ถาม – ตอบ กับผู้เชี่ยวชาญด้านอสังหาริมทรัพย์ ประสบการณ์มากกว่า 10 ปี แบบ Exclusive ได้ตลอดเวลา</li>
												<li>ใบรับรองผ่านการอบรมหลักสูตร START UP AGENT</li>
											</ul>
											<ul
												class="pl-0 pl-sm-3 d-sm-none"
												style="line-height: 1.1em;"
											>
												<li>คอร์สเริ่มต้นอาชีพนายหน้า ไม่มีความรู้เรื่องนายหน้ามาก่อนก็สามารถเรียนได้</li>
												<li>สอนจริงทุกขั้นตอน เนื้อหามืออาชีพเห็นภาพและเข้าใจการทำงานอย่างชัดเจน</li>
												<li>เคล็ดลับเส้นทางสู่ นายหน้ามืออาชีพ ทำงานกันอย่างไร? พบได้ในคอร์สนี้ กับคอร์ส STA 1 วันเต็ม</li>
												<li>เรียนคอร์ส STA จบแล้ว สามารถนำไปปฏิบัติได้จริง สอนตั้งแต่เริ่มต้นหาทรัพย์ ไปจนถึงการโอนกรรมสิทธิ ไม่ต้องลองผิดลองถูก..อีกต่อไป</li>
												<li>ถาม – ตอบ กับผู้เชี่ยวชาญด้านอสังหาริมทรัพย์ ประสบการณ์มากกว่า 10 ปี แบบ Exclusive ได้ตลอดเวลา</li>
												<li>ใบรับรองผ่านการอบรมหลักสูตร START UP AGENT</li>
											</ul>
										</div>

										<img
											src="/images/sta-cover.jpg"
											alt="start up agent cover"
											width="100%"
										>

										<div class="text-center">
											<h2 class="red--text d-none d-md-block">
												หลักสูตร START UP AGENT
											</h2>
											<h3 class="red--text d-none d-sm-block d-md-none">
												หลักสูตร START UP AGENT
											</h3>
											<h4 class="red--text d-sm-none">
												หลักสูตร START UP AGENT
											</h4>

											<b class="d-block my-2">เจาะลึก 1 วันเต็ม ทำอย่างไรถึงจะเป็นนายหน้ามืออาชีพ?</b>

											<h3 class="red--text d-none d-sm-block px-4">
												สำหรับผู้ที่ไม่มีพื้นฐานด้านการเป็นนายหน้าอสังหาฯ มาก่อน หรือผู้ที่ต้องการก้าวสู่อาชีพ นายหน้าอสังหาฯ แบบมืออาชีพอย่างแท้จริง
											</h3>
											<h4 class="red--text d-sm-none px-3">
												สำหรับผู้ที่ไม่มีพื้นฐานด้านการเป็นนายหน้าอสังหาฯ มาก่อน หรือผู้ที่ต้องการก้าวสู่อาชีพ นายหน้าอสังหาฯ แบบมืออาชีพอย่างแท้จริง
											</h4>

											<p class="pb-sm-5 px-5 px-sm-12">
												พร้อมทั้งเรียนรู้เครื่องมือการทำงาน และสิทธิประโยชน์ต่าง ๆ ที่จะพาคุณก้าวสู่เป้าหมายเป็นมืออาชีพในเวลาอันรวดเร็ว และง่ายยิ่งขึ้น
											</p>
										</div>

										<v-row
											no-gutters
											class="sta-privilege white--text"
										>
											<v-col
												cols="12"
												md="8"
												lg="8"
												class="d-flex justify-center justify-md-start align-center"
											>
												<div
													class="sta-ul pt-3 d-inline-block"
													style="font-size: 1.2em;"
												>
													<div class="d-flex align-center mb-3 mb-lg-6 pl-4 pl-sm-7">
														<b
															class="red--text"
															style="font-size: 4em; line-height: 0.75em;"
														>
															3
														</b>
														<div class="pl-5">
															<h3>สิทธิประโยชน์ <span class="red--text">START UP AGENT</span></h3>
															คุณจะได้รับสิทธิ์ประโยชน์ดังนี้
														</div>
													</div>
													<ul class="icon-top pl-0 pl-sm-3">
														<li>
															<h5>ได้เข้าเรียนหลักสูตร <span class="red--text">3 Find 4 Sell</span></h5>
															<small>คอร์ส Exclusive สู่นายหน้ามืออาชีพ (e-Learning)</small>
														</li>
														<li>
															<h5>
																รับฟรี! ชุด STARTER KIT<br>
																พร้อมเริ่มงานได้ทันที <span class="red--text">มูลค่ากว่า 2,700.-</span>
															</h5>
														</li>
														<li>
															<h5>
																ได้เงินค่าคอร์สคืนเต็มจำนวน (Refund)<br>
																พร้อมโบนัส รวมเป็นเงิน <span class="red--text">5,000.-</span>
															</h5>
															<small>* เงื่อนไขเป็นไปตามที่บริษัทฯ กำหนด รายละเอียดเพิ่มเติมใน Instant Intro</small>
														</li>
													</ul>
												</div>
											</v-col>
											<v-col
												cols="4"
												lg="4"
												class="d-none d-md-block"
											>
												<img
													class="mt-n12 ml-n12 mb-n2"
													src="/images/sta-privilege-deco.png"
													alt="start up agent privilege"
													width="120%"
												>
											</v-col>
										</v-row>

										<v-row
											no-gutters
											class="bgRed pa-5"
										>
											<v-col
												cols="12"
												sm="6"
											>
												<img
													src="/images/sta-certificate.jpg"
													alt="start up agent certificate"
													width="100%"
												>
											</v-col>
											<v-col
												cols="12"
												sm="6"
												class="pl-4 d-flex justify-center justify-sm-start align-center text-center text-sm-left"
											>
												<div>
													<span
														class="d-block"
														style="font-size: 1.5em;"
													>
														ใบรับรองผ่านการอบรม<br>หลักสูตร STA ของ
													</span>
													<b
														class="d-block"
														style="font-size: 1.5em;"
													>
														THE BEST PROPERTY<br>AGENT Co.,Ltd.
													</b>
													<b
														class="d-block mt-3 white--text"
														style="font-size: 1.7em;"
													>
														CERTIFICATE
													</b>
													<b
														class="d-block white--text"
														style="font-size: 1.6em;"
													>
														OF APPRECIATION
													</b>
												</div>
											</v-col>
										</v-row>

										<div class="pt-3 px-3 px-sm-4 px-md-8">
											<p>
												<b>หลักสูตร</b>
												<span class="red--text">START UP AGENT รุ่น {{ staInfo.number }}</span>
											</p>
											<p>
												<b>วันและเวลาบรรยาย</b>
												<span class="red--text">{{ staInfo.date }}</span>
											</p>
											<p>
												<b>สถานที่จัดอบรม</b>
												<span class="red--text">{{ staInfo.location }}</span>
											</p>
										</div>

										<img
											src="/images/sta-seminar.jpg"
											alt="start up agent seminar"
											width="100%"
										>

										<div class="pt-3 px-3 px-sm-4 px-md-8">
											<div class="d-sm-none text-center">
												<v-btn
													rounded
													x-large
													color="grey darken-3"
													class="mr-1"
													:outlined="staTab !== 0"
													@click="staTab = 0"
												>
													รายละเอียด
												</v-btn>
												<v-btn
													rounded
													x-large
													color="grey darken-3"
													:outlined="staTab !== 1"
													@click="staTab = 1"
												>
													หัวข้อการอบรม
												</v-btn>
											</div>
											<div class="d-sm-none text-center mt-2">
												<v-btn
													rounded
													x-large
													color="grey darken-3"
													class="px-12 mr-1"
													:outlined="staTab !== 2"
													@click="staTab = 2"
												>
													สิทธิพิเศษ
												</v-btn>
												<v-btn
													rounded
													x-large
													color="grey darken-3"
													:outlined="staTab !== 3"
													@click="staTab = 3"
												>
													ผู้บรรยาย
												</v-btn>
											</div>

											<v-tabs
												v-model="staTab"
												class="d-none d-sm-block"
												slider-color="red"
												active-class="bgRed white--text"
												fixed-tabs
												light
											>
												<v-tab key="staTab-1">
													รายละเอียด
												</v-tab>
												<v-tab key="staTab-2">
													หัวข้อการอบรม
												</v-tab>
												<v-tab key="staTab-3">
													สิทธิพิเศษ
												</v-tab>
												<v-tab key="staTab-4">
													ผู้บรรยาย
												</v-tab>
											</v-tabs>

											<v-tabs-items
												:value="staTab"
												class="px-4 py-3"
											>
												<v-tab-item key="staTab-1">
													<p style="font-size: 1.2em">
														เปิดประสบการณ์ใหม่ ที่ทำให้คุณได้มากกว่าคำว่า “นายหน้าอสังหาฯ”
													</p>
													<p>
														<b>หลักสูตร START UP AGENT คอร์สสำหรับ</b>
														เริ่มต้นอาชีพนายหน้าอสังหาฯ ไม่มีความรู้เรื่องนายหน้ามาก่อนก็สามารถเรียนได้ ให้ความรู้แนะนำวิธีการจนถึงบอกเคล็ดลับการเริ่มต้นอาชีพนายหน้า สู่การเป็นนายหน้ามืออาชีพ พร้อมการใช้ระบบ SMART AGENT SYSTEM เครื่องมือที่จะช่วยให้การทำงานของคุณสะดวก รวดเร็วมากยิ่งขึ้น
													</p>
													<p>
														พิเศษกว่าที่ไหนๆ <span class="red--text">ฟรี!</span> ชุด STARTER KIT พร้อมเริ่มงานได้ทันที มูลค่า 2,700 บาท พร้อมทั้งสิทธิ์ เข้าเรียน e-Learning ยกระดับความรู้นายหน้ามืออาชีพ หลักสูตร Exclusive ที่ไม่มี..ที่ไหนกล้าบอกคุณ!!
													</p>

													<b>หลักสูตรนี้เหมาะสำหรับ</b>
													<ul>
														<li>ผู้ที่ต้องการทำอาชีพนายหน้าอสังหาฯ เป็นอาชีพหลัก</li>
														<li>ผู้ที่ต้องการหารายได้เสริม และต้องการเพิ่มช่องทางรายได้</li>
														<li>ผู้ที่เบื่องานประจำ และกำลังอยากเปลี่ยนงาน</li>
														<li>ผู้ที่ต้องการอิสระด้านเวลา แต่มีรายได้อย่างต่อเนื่อง</li>
														<!--li>ผู้ที่กำลังมองหาธุรกิจที่ใช้เงินลงทุนน้อย และได้ผลตอบแทนสูง</li-->
													</ul>
												</v-tab-item>

												<v-tab-item key="staTab-2">
													<p style="font-size: 1.2em">
														หัวข้อการอบรม <span class="red--text">START UP AGENT</span>
													</p>
													<p>
														1. การเริ่มต้นอาชีพ "นายหน้าอสังหาฯ" ของมือใหม่ สู่มืออาชีพ<br>
														2. การค้นหาทรัพย์<br>
														3. การเตรียมความพร้อมก่อนรับทรัพย์<br>
														4. การประเมินราคาขายอสังหาฯ<br>
														5. สัญญาที่เกี่ยวข้องและรายละเอียดการดำเนินงาน<br>
														6. การคำนวณภาษีค่าโอน<br>
														7. สื่อโฆษณาและการตลาดที่คุณต้องรู้<br>
														8. การเจรจาต่อรอง<br>
														9. เรียนรู้วิธีการคิดและประสบการณ์ของผู้ที่ทำแล้วสำเร็จแบบก้าวกระโดด
													</p>
												</v-tab-item>

												<v-tab-item key="staTab-3">
													<b>สิทธิพิเศษ</b>
													<ul>
														<li><span class="red--text">ฟรี!</span> เอกสารประกอบการบรรยาย</li>
														<li><span class="red--text">ฟรี!</span> ชุด STARTER KIT พร้อมเริ่มงานได้ทันที มูลค่า 2,700 บาท</li>
														<li><span class="red--text">ฟรี!</span> สมัครเข้าเป็น นายหน้าอสังหาฯ (Agent) ของ The Best Property</li>
														<li><span class="red--text">ฟรี!</span> ยกระดับความรู้สำหรับนายหน้ามืออาชีพ ด้วย e-Learning หลักสูตร Exclusive ที่ไม่มี..ที่ไหนกล้าบอกคุณ!!</li>
														<li>Agent Networking เพื่อพูดคุย แชร์ประสบการณ์ และหารือ รับคำปรึกษา</li>
														<li>มีทรัพย์มากกว่า 20,000 รายการ ให้คุณพร้อมขาย..ทันที</li>
														<li>ถาม – ตอบ กับผู้เชี่ยวชาญด้านอสังหาริมทรัพย์ ประสบการณ์มากกว่า 10 ปี แบบ Exclusive ได้ตลอดเวลา</li>
														<li>ใบประกาศนียบัตรผ่านการอบรมหลักสูตร START UP AGENT</li>
													</ul>
												</v-tab-item>

												<v-tab-item key="staTab-4">
													<p style="font-size: 1.2em">
														ผู้บรรยาย <span class="red--text">Speaker</span>
													</p>
													<v-row class="align-sm-center text-center text-sm-left">
														<v-col
															cols="6"
															sm="3"
															offset="3"
															offset-sm="2"
														>
															<img
																src="/images/sta-speaker-1.png"
																alt="start up agent speaker 1"
																width="100%"
															>
														</v-col>
														<v-col
															cols="12"
															sm="7"
															class="mb-6"
														>
															<b
																class="red--text"
																style="font-size: 1.2em"
															>
																คุณเต้ย ณัฏฐ์ภณ ลีลาทวีพัฒน์
															</b><br>
															<b>Founder</b><br>
															<b>ประธานผู้ก่อตั้ง</b><br>
															The Best Property Agent Co.,Ltd.
														</v-col>

														<v-col
															cols="6"
															sm="3"
															offset="3"
															offset-sm="2"
														>
															<img
																src="/images/sta-speaker-2.png"
																alt="start up agent speaker 2"
																width="100%"
															>
														</v-col>
														<v-col
															cols="12"
															sm="7"
															class="mb-6"
														>
															<b
																class="red--text"
																style="font-size: 1.2em"
															>
																คุณตี๋เบิร์ด คุณกฤษฎี ธรรมาภิวันท์
															</b><br>
															<b>Chief Executive Officer (CEO)</b><br>
															<b>ประธานเจ้าหน้าที่บริหาร</b><br>
															The Best Property Agent Co.,Ltd.
														</v-col>

														<v-col
															cols="6"
															sm="3"
															offset="3"
															offset-sm="2"
														>
															<img
																src="/images/sta-speaker-3.png"
																alt="start up agent speaker 3"
																width="100%"
															>
														</v-col>
														<v-col
															cols="12"
															sm="7"
															class="mb-6"
														>
															<b
																class="red--text"
																style="font-size: 1.2em"
															>
																คุณฟี่ พรชนก ชนะอุทัย
															</b><br>
															<b>General Manager (GM)</b><br>
															<b>ผู้จัดการทั่วไป</b><br>
															The Best Property Agent Co.,Ltd.
														</v-col>
													</v-row>
												</v-tab-item>
											</v-tabs-items>
										</div>

										<div class="text-center red--text mt-8">
											<b style="font-size: 1.2em;">
												คอร์ส START UP AGENT
											</b><br>
											<b style="font-size: 1.5em;">
												<!-- พิเศษเพียง 2,990 บาท/ท่าน เท่านั้น -->
												เข้าฟัง Instant Intro
											</b>
										</div>
										<div class="px-sm-12">
											<v-btn
												rounded
												x-large
												color="red"
												class="d-block mx-auto"
												@click="goRegister"
											>
												เข้าร่วมฟัง Instant Intro ที่นี่
											</v-btn>
											<v-btn
												rounded
												x-large
												class="d-block mx-auto mt-2"
												color="grey darken-3"
												@click="step1Selected = true"
											>
												ดำเนินการต่อ (ลงทะเบียนแล้ว)
											</v-btn>
										</div>

										<div class="text-center red--text mt-8">
											<b style="font-size: 1.4em;">
												Speakers (ผู้บรรยายหลัก)
											</b>
										</div>

										<img
											src="/images/sta-speaker-01.jpg"
											alt="start up agent speaker 1"
											width="100%"
											class="mb-n2"
										>
										<img
											src="/images/sta-speaker-02.jpg"
											alt="start up agent speaker 2"
											width="100%"
											class="mb-n2"
										>
										<img
											src="/images/sta-speaker-03.jpg"
											alt="start up agent speaker 3"
											width="100%"
											class="mb-n2"
										>

										<img
											src="/images/sta-office.png"
											alt="start up agent office"
											width="100%"
											class="my-6"
										>

										<p class="text-center px-3">
											<b style="font-size: 1.5em;">การเดินทางสู่ความสำเร็จในวงการอสังหาริมทรัพย์</b>
										</p>
										<p class="text-center px-6 mx-sm-12 px-sm-12">
											<b style="font-size: 1.2em;">SMART AGENT SYSTEM</b>
											เราจะพาให้คุณรู้ถึง “เคล็ดลับ” ที่ไม่มีใครอย่างบอกให้คุณฟัง ในวงการอสังหาฯ พร้อมทั้ง ส่งต่อความรู้และประสบการณ์มากมาย จากคณาจารย์ วิทยากร และเพื่อนๆ มาช่วยให้คุณทะยานสู่ความสำเร็จ..ไปด้วยกัน
										</p>

										<div class="d-flex px-6 mb-4 align-center">
											<img
												src="/images/sta-key-01.png"
												alt="start up agent success key 1"
												class="offset-sm-2"
												width="80"
											>
											<div class="ml-3">
												<b
													class="red--text"
													style="font-size: 1.2em"
												>
													AGENT System
												</b><br>
												ระบบจัดการอสังหาฯ ช่วยให้ประเมิน ราคาขายที่ใช่ และปิดการขายได้เร็วที่สุด
											</div>
											<div class="offset-sm-2" />
										</div>
										<div class="d-flex px-6 mb-4 align-center">
											<img
												src="/images/sta-key-02.png"
												alt="start up agent success key 1"
												class="offset-sm-2"
												width="80"
											>
											<div class="ml-3">
												<b
													class="red--text"
													style="font-size: 1.2em"
												>
													THE BEST e-Learning
												</b><br>
												เน้นความรู้ ในทุกๆ มิติ ที่จะช่วยให้คุณรู้จัก และเข้าใจเรื่องอสังหาฯ อย่างมืออาชีพ
											</div>
											<div class="offset-sm-2" />
										</div>
										<div class="d-flex px-6 mb-4 align-center">
											<img
												src="/images/sta-key-03.png"
												alt="start up agent success key 1"
												class="offset-sm-2"
												width="80"
											>
											<div class="ml-3">
												<b
													class="red--text"
													style="font-size: 1.2em"
												>
													THE BEST Marketing
												</b><br>
												มีทีมโฆษณาบนโลกออนไลน์ ออฟไลน์ ให้ฟรี!! และมีตัวแทนช่วยกันขายมากกว่า 1,900 คน
											</div>
											<div class="offset-sm-2" />
										</div>
										<div class="d-flex px-6 mb-4 align-center">
											<img
												src="/images/sta-key-04.png"
												alt="start up agent success key 1"
												class="offset-sm-2"
												width="80"
											>
											<div class="ml-3">
												<b
													class="red--text"
													style="font-size: 1.2em"
												>
													THE BEST Finance
												</b><br>
												ทีมสินเชื่อมืออาชีพ พร้อมดีลทุกธนาคาร อำนวยความสะดวกให้ตัวแทนทุกขั้นตอน
											</div>
											<div class="offset-sm-2" />
										</div>
										<div class="d-flex px-6 mb-4 align-center">
											<img
												src="/images/sta-key-05.png"
												alt="start up agent success key 1"
												class="offset-sm-2"
												width="80"
											>
											<div class="ml-3">
												<b
													class="red--text"
													style="font-size: 1.2em"
												>
													THE BEST Law
												</b><br>
												ทีมกฎหมาย พร้อมดูแลเอกสารสัญญา เพื่อสนับสนุนตัวแทนทุกคน
											</div>
											<div class="offset-sm-2" />
										</div>
										<div class="d-flex px-6 mb-4 align-center">
											<img
												src="/images/sta-key-06.png"
												alt="start up agent success key 1"
												class="offset-sm-2"
												width="80"
											>
											<div class="ml-3">
												<b
													class="red--text"
													style="font-size: 1.2em"
												>
													THE BEST Reward
												</b><br>
												รายได้จากการขายและบริหารทีมพร้อมทริปการท่องเที่ยวต่างประเทศฟรีทุกปี
											</div>
											<div class="offset-sm-2" />
										</div>

										<p
											class="px-6 mt-12"
											style="font-size: 1.2em;"
										>
											เก็บตกบรรยากาศ หลักสูตรการอบรม <span class="red--text">START UP AGENT</span>
										</p>
										<img
											src="/images/sta-attendants-01.jpg"
											alt="start up agent attendants 1"
											width="100%"
										>
										<img
											src="/images/sta-attendants-02.jpg"
											alt="start up agent attendants 2"
											width="100%"
										>
										<img
											src="/images/sta-attendants-03.jpg"
											alt="start up agent attendants 3"
											width="100%"
										>
										<img
											src="/images/sta-attendants-04.jpg"
											alt="start up agent attendants 4"
											width="100%"
										>
										<img
											src="/images/sta-attendants-05.jpg"
											alt="start up agent attendants 5"
											width="100%"
										>
										<img
											src="/images/sta-attendants-06.jpg"
											alt="start up agent attendants 6"
											width="100%"
										>

										<div class="mt-10 mx-4 mx-sm-12 mx-md-12 px-md-12">
											<p style="line-height: 2.2em;">
												<b style="font-size: 2.2em;">หลักสูตร</b><br>
												<b
													class="red--text d-block"
													style="font-size: 1.7em;"
												>
													START UP AGENT
												</b>
												<b
													class="red--text"
													style="font-size: 2.6em;"
												>
													AGENDA
												</b>
											</p>

											<v-row>
												<template>
													<v-col
														v-for="course in staInfo.courses || []"
														:key="`course-${course.number}`"
														:cols="course.status === 'เปิดคอร์ส' ? 12 : 6"
													>
														<v-card
															color="grey lighten-2"
															elevation="0"
															:height="course.status === 'เปิดคอร์ส' ? 100 : 70"
															class="sta-agenda-card d-flex justify-center flex-column"
															:class="{'closed': course.status === 'ปิดคอร์ส', 'opened pl-0 pl-sm-12': course.status === 'เปิดคอร์ส'}"
															light
														>
															<b>รุ่นที่ {{ course.number }}</b>
															<div v-if="course.status !== 'ปิดคอร์ส'">
																{{ course.date }}
															</div>
															<div v-if="course.status === 'เปิดคอร์ส'">
																เปิดลงทะเบียน
															</div>
														</v-card>
													</v-col>
												</template>
											</v-row>
										</div>

										<div class="text-center red--text mt-8">
											<b style="font-size: 1.2em;">
												คอร์ส START UP AGENT
											</b><br>
											<b style="font-size: 1.5em;">
												<!-- พิเศษเพียง 2,990 บาท/ท่าน เท่านั้น -->
												เข้าฟัง Instant Intro
											</b>
										</div>
										<div class="px-sm-12 pb-4">
											<v-btn
												rounded
												x-large
												color="red"
												class="d-block mx-auto"
												@click="goRegister"
											>
												เข้าร่วมฟัง Instant Intro ที่นี่
											</v-btn>
											<v-btn
												rounded
												x-large
												class="d-block mx-auto mt-2"
												color="grey darken-3"
												@click="step1Selected = true"
											>
												ดำเนินการต่อ (ลงทะเบียนแล้ว)
											</v-btn>
										</div>
									</div>

									<!-- <v-card
										v-else
										class="mb-6 pa-8 pb-4"
									> -->
									<div v-else>
										<v-alert
											type="error"
											dismissible
											:value="!!alertMsg"
										>
											{{ alertMsg }}
										</v-alert>

										<!-- <div v-if="!step1Selected">
											<h2
												class="text-center mb-3"
												style="line-height: 1.3em;"
											>
												ลงทะเบียน<br>
												<span
													class="red--text"
													style="font-style: italic;"
												>
													INSTANT INTRO
												</span><br>
												เข้ารับชมออนไลน์ <span class="red--text">ฟรี!</span>
											</h2>
											<img
												src="/images/guest-registration-intro.jpg?v=3"
												alt="guest-registration-intro"
												width="100%"
											>
											<div class="px-sm-12">
												<h3
													class="text-center my-4"
													style="font-weight: bolder;"
												>
													เส้นทางของ นายหน้าอสังหาฯ<br>
													เงินล้าน <span class="red--text">เริ่มต้นที่นี่</span>
												</h3>
												<v-btn
													block
													color="primary"
													@click="regStep = 2"
												>
													กรอกข้อมูลลงทะเบียน
												</v-btn>
												<v-btn
													block
													class="mt-2"
													color="primary"
													@click="step1Selected = true"
												>
													ดำเนินการต่อ (ลงทะเบียนแล้ว)
												</v-btn>
											</div>
										</div> -->

										<v-form
											ref="stepPhoneVerify"
											v-model="stepPhoneVerify"
											class="d-sm-flex"
											style="gap: 10px;"
											lazy-validation
										>
											<v-text-field
												v-model="phone"
												label="เบอร์โทรศัพท์ *"
												append-icon="call"
												maxlength="10"
												:counter="10"
												:rules="[ v => !!v || 'จำเป็นต้องกรอกเบอร์โทรศัพท์', v => (v && /[\d]{10}/.test(v)) || 'เบอร์โทรศัพท์ไม่ถูกต้อง' ]"
												filled
												dense
												required
												@keyup="phoneFormat"
												@keydown.enter.prevent="stepPhoneValidation"
											/>
											<v-text-field
												v-model="email"
												label="อีเมล *"
												append-icon="alternate_email"
												:rules="[ v => !!v || 'จำเป็นต้องกรอกอีเมล', v => (v && emailValidate(v)) || 'อีเมลไม่ถูกต้อง' ]"
												filled
												dense
												required
												@keydown.enter.prevent="stepPhoneValidation"
											/>
										</v-form>
									</div>
									<!-- </v-card> -->

									<v-row no-gutters>
										<v-btn
											v-if="step1Selected"
											class="mr-auto"
											color="primary"
											:disabled="loading"
											@click="step1Selected = false; regStep = 2;"
										>
											กรอกข้อมูลลงทะเบียน
										</v-btn>
										<v-btn
											v-if="step1Selected"
											color="primary"
											:loading="loading"
											:disabled="loading"
											@click="stepPhoneValidation"
										>
											ถัดไป
										</v-btn>
									</v-row>
								</v-stepper-content>

								<v-stepper-content step="2">
									<!-- <v-card class="mb-6 px-8 py-4"> -->
									<v-alert
										type="error"
										dismissible
										:value="stepGuestInfoAlert"
									>
										{{ stepGuestInfoMsg }}
									</v-alert>

									<v-form
										ref="stepGuestInfo"
										v-model="stepGuestInfoValid"
										autocomplete="off"
										lazy-validation
										@keydown.enter.prevent="stepGuestInfoValidation"
									>
										<v-row>
											<v-col>
												<v-alert
													type="error"
													dismissible
													:value="infoAlert"
												>
													{{ infoAlertMsg }}
												</v-alert>
											</v-col>
										</v-row>

										<v-row no-gutters>
											<!-- <v-col
												cols="12"
												sm="7"
												class="pa-1"
											>
												<v-text-field
													v-model="fullname"
													label="ชื่อ-สกุล *"
													:rules="[ v => !!v || 'จำเป็นต้องกรอกชื่อ-สกุล' ]"
													required
													filled
													dense
												/>
											</v-col> -->

											<v-col
												cols="12"
												sm="4"
												class="pa-1"
											>
												<v-text-field
													v-model="name"
													label="ชื่อ * (ภาษาไทย)"
													:rules="[ v => !!v || 'จำเป็นต้องกรอกชื่อ' ]"
													required
													filled
													dense
													@keyup="thaiCheck('name')"
												/>
											</v-col>


											<v-col
												cols="12"
												sm="5"
												class="pa-1"
											>
												<v-text-field
													v-model="lastname"
													label="สกุล * (ภาษาไทย)"
													:rules="[ v => !!v || 'จำเป็นต้องกรอกสกุล' ]"
													required
													filled
													dense
													@keyup="thaiCheck('lastname')"
												/>
											</v-col>

											<v-col
												cols="12"
												sm="3"
												class="pa-1"
											>
												<v-text-field
													v-model="nickname"
													label="ชื่อเล่น * (ภาษาไทย)"
													:rules="[ v => !!v || 'จำเป็นต้องกรอกชื่อเล่น' ]"
													required
													filled
													dense
													@keyup="thaiCheck('nickname')"
												/>
											</v-col>

											<v-col
												cols="12"
												sm="4"
												md="3"
												class="pa-1"
											>
												<client-only>
													<v-select
														v-model="provinceSelected"
														:items="location"
														:menu-props="{ maxHeight: '400', offsetY: false }"
														:rules="[v => !!v || 'จำเป็นต้องเลือกจังหวัด']"
														item-text="n"
														item-value="p"
														label="เลือกจังหวัด *"
														return-object
														filled
														dense
														required
													/>
												</client-only>
											</v-col>

											<v-col
												cols="12"
												sm="8"
												md="9"
												class="pa-1"
											>
												<v-text-field
													v-model="facebook"
													label="Facebook *"
													:rules="[ v => !!v || 'จำเป็นต้องกรอก Facebook' ]"
													filled
													dense
													required
												/>
											</v-col>

											<v-col
												cols="12"
												sm="5"
												class="pa-1"
											>
												<v-text-field
													v-model="phone"
													label="เบอร์ติดต่อ *"
													maxlength="10"
													:counter="10"
													:rules="[ v => !!v || 'จำเป็นต้องกรอกเบอร์ติดต่อ', v => (v && /[\d]{10}/.test(v)) || 'เบอร์ติดต่อไม่ถูกต้อง' ]"
													filled
													dense
													required
													@keyup="phoneFormat"
												/>
											</v-col>
											<v-col
												cols="12"
												sm="7"
												class="pa-1"
											>
												<v-text-field
													v-model="email"
													label="อีเมล *"
													:rules="[ v => !!v || 'จำเป็นต้องกรอกอีเมล', v => (v && emailValidate(v)) || 'อีเมลไม่ถูกต้อง' ]"
													filled
													dense
													required
												/>
											</v-col>

											<v-col
												cols="12"
												sm="7"
												class="pa-1"
											>
												<v-text-field
													v-model="lineID"
													label="Line ID *"
													:rules="[ v => !!v || 'จำเป็นต้องกรอก Line ID' ]"
													filled
													dense
													required
												/>
											</v-col>

											<v-col
												cols="12"
												sm="5"
												class="pa-1"
											>
												<v-text-field
													v-model="reference_agent_id"
													label="รหัสผู้แนะนำ"
													:rules="[ v => (!v || /[\d]{4}/.test(v)) || 'รหัสตัวแทนไม่ถูกต้อง' ]"
													:disabled="fixRef"
													maxlength="4"
													filled
													dense
												/>
											</v-col>

											<!-- <v-col
												cols="12"
												sm="4"
												class="pa-1"
											>
												<v-text-field
													v-model="reference_ae_id"
													label="รหัสผู้แนะนำ (AE ในสายงาน)"
													:rules="[ v => (!v || /[\d]{4}/.test(v)) || 'รหัสตัวแทนไม่ถูกต้อง' ]"
													maxlength="4"
													filled
													dense
												/>
											</v-col> -->

											<v-col
												cols="12"
												sm="5"
												class="pa-1 white--text"
											>
												<!-- <v-text-field
													v-model="from_channel"
													label="ท่านเห็นช่องทางการสมัครจากที่ใด *"
													:rules="[ v => !!v || 'จำเป็นต้องกรอก' ]"
													required
													filled
													dense
												/> -->
												<div class="mb-2">
													ท่านเห็นช่องทางการสมัครจากที่ใด? *
												</div>
												<v-radio-group
													v-model="from_channel"
													:rules="[ v => !!v || 'จำเป็นต้องเลือก' ]"
													hide-details
													required
												>
													<v-radio
														label="Facebook"
														value="Facebook"
													/>
													<v-radio
														label="LINE"
														value="LINE"
													/>
													<v-radio
														label="Instagram (IG)"
														value="Instagram (IG)"
													/>
													<v-radio
														label="TIKTOK"
														value="TIKTOK"
													/>
													<v-radio
														label="Website"
														value="Website"
													/>
													<v-radio
														label="มีผู้แนะนำ"
														value="มีผู้แนะนำ"
													/>
													<v-radio
														label="อื่นๆ:"
														value="อื่นๆ"
													>
														<!-- <template v-slot:label>
															อื่นๆ:
															<v-text-field
																v-model="from_channel"
																:rules="[ v => !!v || 'จำเป็นต้องกรอก' ]"
																hide-details
																required
																dense
															/>
														</template> -->
													</v-radio>
													<v-text-field
														v-model="from_channel_other"
														:rules="[ v => from_channel !== 'อื่นๆ' || !!v || 'จำเป็นต้องกรอก' ]"
														:disabled="from_channel !== 'อื่นๆ'"
														class="ml-7 mb-6"
														hide-details
														dense
													/>
												</v-radio-group>
											</v-col>

											<v-col
												cols="12"
												sm="7"
												class="pa-1 white--text"
											>
												<!-- <v-text-field
													v-model="contact_channel"
													label="สะดวกให้ทางบริษัท ติดต่อให้ข้อมูลเพิ่มเติมในช่องทางใด *"
													:rules="[ v => !!v || 'จำเป็นต้องกรอก' ]"
													required
													filled
													dense
												/> -->
												<div class="mb-2">
													สะดวกให้ทางบริษัท ติดต่อให้ข้อมูลในช่องทางใด? *
												</div>
												<v-checkbox
													v-model="contact_channel"
													:rules="[ v => (!!v && v.length > 0) || 'จำเป็นต้องเลือกช่องทางติดต่อ' ]"
													hide-details
													class="mt-0"
													label="โทรศัพท์"
													value="โทรศัพท์"
												/>
												<v-checkbox
													v-model="contact_channel"
													:rules="[ v => (!!v && v.length > 0) || 'จำเป็นต้องเลือกช่องทางติดต่อ' ]"
													hide-details
													class="mt-0"
													label="LINE"
													value="LINE"
												/>
											</v-col>
										</v-row>
									</v-form>
									<!-- </v-card> -->

									<div class="agreement-detail mt-4">
										ในการดำเนินการลงทะเบียนนี้ ข้าพเจ้ายอมรับ
										<v-btn
											color="red"
											class="pa-0 mb-1"
											height="min-content"
											text
											@click="usageDialog = true"
										>
											ข้อกําหนดการใช้งาน
										</v-btn>
										และ
										<v-btn
											color="red"
											class="pa-0 mb-1"
											height="min-content"
											text
											@click="privacyDialog = true"
										>
											นโยบายความเป็นส่วนตัว
										</v-btn>
										ของ The Best Property Agent
									</div>

									<v-row no-gutters>
										<v-btn
											class="mr-auto"
											color="primary"
											:disabled="loading"
											@click="step1Selected = false; regStep=1;"
										>
											ย้อนกลับ
										</v-btn>
										<v-btn
											color="primary"
											:loading="loading"
											:disabled="loading"
											@click="stepGuestInfoValidation"
										>
											ถัดไป
										</v-btn>
									</v-row>
								</v-stepper-content>

								<v-stepper-content
									step="3"
									class="px-0 white--text"
								>
									<v-alert
										type="error"
										dismissible
										:value="stepVideoAlert"
									>
										{{ stepVideoMsg }}
									</v-alert>

									<h3
										class="text-center mb-3"
										style="color: #BDBDBD;"
									>
										เส้นทางสู่
										<span
											class="red--text"
											style="font-weight: bolder;"
										>
											"ความสําเร็จ"
										</span><br>
										นายหน้าอสังหาฯ
										ต้องเริ่มอย่างไร?<br>
										รับชม..จบแล้ว <b class="red--text">ตัดสินใจได้เลย</b>
									</h3>
									<div
										ref="videoRef"
										class="mx-auto mb-5"
										style="width: 100%;"
									/>

									<template v-if="agreementAvailable">
										<!-- <div
											class="text-md-center mb-3"
											style="color: #BDBDBD;"
										>
											<b class="red--text">ข้อตกลงและเงื่อนไข</b>
											<b> (Terms & Conditions)</b>
										</div>

										<v-card class="mb-6 px-8 pt-10 pb-4">
											<v-form
												ref="stepAgreementForm"
												v-model="stepAgreementFormValid"
												lazy-validation
											>
												<div class="agreement-detail">
													ข้อกําหนดและเงื่อนไขสําหรับ การสมัครสมาชิก
												</div>
												<v-checkbox
													v-model="policyAccept"
													:rules="[v => !!v || 'คุณจำเป็นต้องเข้าใจและยอมรับข้อตกลง!']"
													label="ฉันยอมรับข้อกำหนดในการให้บริการและนโยบาย ความเป็นส่วนตัว"
													required
													@keydown.enter.prevent="stepAgreementValidation"
												/>
											</v-form>
										</v-card> -->

										<h3 class="text-center white--text">
											<b class="red--text">“แล้วคุณล่ะ ”</b> ..พร้อมจะมาเป็นครอบครัว<br>
											The Best Property Agent
											<span class="red--text">แล้วหรือยัง?</span>
										</h3>

										<img
											src="/images/guest-course.jpg?v=4"
											alt="guest-course"
											class="my-4"
											width="100%"
										>

										<h3 class="text-center white--text">
											<b class="red--text">รับฟรี!</b>
											อุปกรณ์การทํางาน Starter Kit
										</h3>
										<h2 class="text-center white--text">
											<b>มูลค่ารวมกว่า
												<span class="red--text">2,700</span>
											</b>
											บาท
										</h2>
									</template>

									<v-row no-gutters>
										<v-btn
											v-if="agreementAvailable"
											color="red"
											class="mx-auto mt-4"
											:loading="loading"
											:disabled="loading"
											@click="stepAgreementValidation"
										>
											สมัครคอร์ส START UP AGENT
										</v-btn>
									</v-row>
								</v-stepper-content>

								<v-stepper-content
									step="4"
									class="px-0 white--text"
								>
									<v-alert
										type="error"
										dismissible
										:value="stepCourseAlert"
									>
										{{ stepCourseMsg }}
									</v-alert>

									<client-only>
										<template v-if="course.countdown">
											<flip-countdown :deadline="course.countdown" />
										</template>
									</client-only>

									<!-- <v-card class="mb-6 px-8 py-4"> -->
									<div class="text-center">
										<h3>
											<b
												class="red--text"
												style="font-weight: bolder;"
											>
												ข้อเสนอพิเศษ
											</b>
											สมัครภายใน 24 ชม.<br>
											คอร์ส
											<b style="font-weight: bolder;">
												START UP AGENT
											</b><br>
											สํารองจ่ายเพียง
											<b
												class="red--text"
												style="font-weight: bolder;"
											>
												2,990 บาท
											</b><br>
											จากราคาปกติ 7,990 บาท
										</h3>

										<img
											src="/images/guest-startup.jpg?v=5"
											alt="guest-startup"
											class="my-4"
											width="100%"
										>

										<h4>
											<b
												class="red--text"
												style="font-weight: bolder;"
											>
												รับฟรี!
											</b>
											อุปกรณ์การทํางาน Starter Kit
										</h4>
										<h3>
											<b style="font-weight: bolder;">
												มูลค่ารวมกว่า
												<span class="red--text">2,700</span>
												บาท
											</b>
										</h3>

										<v-card
											color="red"
											class="mt-3 mb-1 mx-auto px-4 py-2"
											max-width="250"
											dark
										>
											หลักสูตร Offline สํารองที่นั่งด่วน
											<b>รับเพียง 70 ท่าน/เดือน</b>
											เท่านั้น
										</v-card>

										<h3 class="red--text mb-4">
											ขณะนี้เหลือเพียง {{ course.space || '...' }} ที่นั่ง เท่านั้น
										</h3>

										<h3>
											คอร์ส <span class="red--text">START UP AGENT</span> รุ่นที่ {{ course.number || '...' }}
										</h3>
										<h4 class="px-6">
											รับสิทธิพิเศษก่อนใครแบบ Exclusive<br><br>
											อบรมวันที่ {{ course.date || '.........' }} เวลา {{ course.time || '......' }}<br>
											สถานที่: {{ course.location || 'ห้องประชุม The Best Property Agent' }}
										</h4>
										<div
											class="mx-auto mt-6 px-6 px-sm-0"
											style="max-width: 400px;"
										>
											<h3 class="text-left pl-sm-8">
												ช่องทางการเข้าอบรม
											</h3>
											<v-radio-group
												v-model="course.choice"
												class="mt-1"
												:disabled="loading"
												@change="courseChange"
											>
												<v-radio
													color="red"
													value="offline"
												>
													<template #label>
														<b style="font-size: 1.2rem;">
															<span class="red--text">หลักสูตรปกติ</span>
															- Offline Course
														</b>
													</template>
												</v-radio>
												<div class="d-flex pl-sm-10">
													<div>สิ่งที่จะได้รับ</div>
													<div class="pl-2">
														1. ชุด Starter Kit มูลค่ารวมกว่า 2,700 บาท<br>
														2. เอกสารคู่มือการอบรม<br>
														3. บุฟเฟต์สัมมนา
													</div>
												</div>
												<v-radio
													color="red"
													value="online"
												>
													<template #label>
														<b style="font-size: 1.2rem;">
															<span class="red--text">หลักสูตรออนไลน์</span>
															- Online Course
														</b>
													</template>
												</v-radio>
												<div class="d-flex pl-sm-10">
													<div>สิ่งที่จะได้รับ</div>
													<div class="pl-2">
														1. ชุด Starter Kit มูลค่ารวมกว่า 2,700 บาท<br>
														2. เอกสารคู่มือการอบรม (ไฟล์ PDF)
													</div>
												</div>
												<div class="pl-sm-10">
													หมายเหตุ: จัดส่งหลังจากวันที่อบรม 2-3 วัน
												</div>
											</v-radio-group>

											<h3 class="text-left">
												ขั้นตอนการสมัคร
											</h3>
											<h2 class="text-left red--text">
												คอร์ส START UP AGENT
											</h2>

											<h3 class="text-left mt-2">
												1. เลือกช่องทางการเข้าอบรม<br>
												2. ชําระเงินผ่านบัญชีบริษัท
											</h3>

											<p
												class="text-left mt-6"
												style="font-weight: bold;"
											>
												ธนาคารกสิกรไทย<br>
												เลขที่บัญชี 072-2-58548-8<br>
												ชื่อบัญชี: บจก.เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์
											</p>

											<h3 class="mt-2">
												สํารองจ่ายเพียง
												<span class="red--text">2,990</span>
												บาท
											</h3>

											<img
												src="/images/bank-QR.jpg?v=3"
												alt="bank QR Code"
												class="my-4 mx-auto"
												width="95%"
											>

											<h3 class="text-left">
												3. ส่งหลักฐานการโอนเงินเพื่อยืนยัน<br>
												LINE ID :
												<a
													style="color: green; text-decoration: none;"
													href="https://line.me/ti/p/@Thebestagent"
													title="ไลท์แชทกับ The Best Property ไอดี @Thebestagent"
													target="_blank"
												>
													@Thebestagent
												</a><br>
												หรือคลิกปุ่มข้างล่าง
											</h3>
										</div>
									</div>
									<!-- </v-card> -->

									<div class="text-center">
										<v-btn
											color="green"
											href="https://line.me/ti/p/@Thebestagent"
											title="ไลท์แชทกับ The Best Property ไอดี @Thebestagent"
											target="_blank"
											@click="() => {}"
										>
											ส่งสลิปการโอนทาง Line
										</v-btn>
									</div>
								</v-stepper-content>
							</v-stepper-items>
						</v-stepper>
					</client-only>
				</v-col>
			</v-row>
		</v-container>
	</v-main>
</template>

<script>

const doc = 'guestRegister'

import { mapActions, mapGetters } from 'vuex'
// import Player from '@vimeo/player'
// import FlipCountdown from 'vue2-flip-countdown'

export default {
	name: 'GUESTREGISTER',
	scrollToTop: true,

	components: {
		// [process.client && 'Player']: () => import('@vimeo/player'),
		[process.client && 'FlipCountdown']: () => import('vue2-flip-countdown'),
	},

	async fetch(context) {
		await context.store.dispatch('page/initial', {
			doc: doc,
			fullPath: context.route.fullPath
		})
	},

	data:() => ({
		usageDialog: false,
		privacyDialog: false,

		step1Selected: false,

		keepAliveActivated: false,
		loading: true,
		dialog: false,
		urlValid: false,//
		regStep: 1, //
		stepGuestInfoValid: true,
		stepAgreementFormValid: true,
		alertMsg: false,
		videoFinished: false,
		agreementAvailable: false,
		course: {},

		district: [],
		subDistrict: [],
		current_district: [],
		current_subDistrict: [],

		stepPhoneVerify : false,

		infoAlert: false,
		infoAlertMsg: '',

		fullname: '',
		name: '',
		lastname: '',
		nickname: '',
		provinceSelected: null,
		phone: '',
		email: '',
		lineID: '',
		facebook: '',
		reference_agent_id: '',
		reference_ae_id: '',
		contact_channel: [],
		from_channel: '',
		from_channel_other: '',

		fixRef: false,

		stepGuestInfoAlert: false,
		stepGuestInfoMsg: '',
		stepVideoAlert: false,
		stepVideoMsg: '',
		stepAgreementAlert: false,
		stepAgreementMsg: '',
		stepCourseAlert: false,
		stepCourseMsg: '',

		policyAccept: false,

		staTab: 0,
		staInfo: {}
	}),

	computed: {
		...mapGetters({
			head: 'page/head',
			location: 'location',
		})
	},

	watch: {
		provinceSelected (newVal) {
			if (newVal) {
				this.district = this.provinceSelected.v
			}
			this.districtSelected = null
		}
	},

	created () {
		this.urlValid = true
		// this.phone = '0800000004'
		// this.email = 'gh@ij.kl'
		// this.course.countdown = '2024-02-09 17:09:27'
		// this.agreementAvailable = true
		// this.videoInit()

		// this.regStep = 4
		this.loading = false
	},

	mounted () {
		if (this.$route.query && this.$route.query.ref) {
			this.reference_agent_id = this.$route.query.ref
		} else {
			this.reference_agent_id = '1002'
		}
		this.fixRef = true

		if (process.client) {
			this.loading = true
			this.$fireDb.ref('/configs/GUEST_REGISTER').once('value').then(snapshot => {
				if (snapshot.exists()) {
					this.staInfo = snapshot.val()
				}
			}).finally(() => {
				this.loading = false
			})
		}
	},

	methods: {
		...mapActions({
			urlValidation: 'agent/urlValidation',
			agentSubmitInfo: 'agent/agentSubmitInfo',
		}),

		phoneFormat () {
			this.phone = this.phone.replaceAll(/\D/g, '')
		},

		thaiCheck (field) {
			this[field] = this[field].replaceAll(/[^ก-๏\s]+/g, '')
		},

		emailValidate (email) {
			return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase())
		},

		videoInit () {
			if (process.client) {
				this.$nextTick(() => {
					setTimeout(async () => {
						let curtime = 0
						const elm = this.$refs.videoRef
						const Player = await import('@vimeo/player')
						const player = new Player.default(elm, {
							id: 913596378, // 904713848,
							width: elm.offsetWidth,
							height: elm.offsetWidth * 1.78, // 0.5625,
							autoplay: true,
							// progress_bar: false,
							// controls: false,
							keyboard: false
						})
						// const duration = await player.getDuration()
						// player.on('play', () => {
						// 	console.log('played the video!')
						// })
						// player.on('ended', () => {
						// 	console.log('ended')
						// })

						player.on('timeupdate', info => {
							// if (info.duration - info.seconds < 7) {
							if (info.duration - curtime < 7) {
								if (!this.videoFinished) {
									this.videoFinished = true
									this.stepVideoValidation()
								}
							}

							if(info.seconds < curtime + 1 && info.seconds > curtime) {
								/**
								 * Above is where I hack it.
									I only update the current time if the timeupdate is less than a second ago (therefore proabaly not seeked to).
									This stops the function from just updating curtime to the seeked time.
									But I feel it's not the best way.
								 */
								curtime = info.seconds
							}
						})
						player.on('seeked', (data) => {
							if(data.seconds > curtime) {
								player.setCurrentTime(curtime)
							}
						})
					})
				}, 100)
			}
		},

		stepPhoneValidation () {
			if (this.$refs.stepPhoneVerify.validate()) {
				this.alertMsg = false
				this.loading = true

				this.$fireFunc.httpsCallable('agent-registerLogin')({
					phone: this.phone,
					email: this.email
				}).then(({data}) => {
					if (data.error) {
						this.alertMsg = data.error.message || 'พบปัญหาการตรวจสอบข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
					} else {
						if (data.guest_register) {
							// let countdown = null
							if (data.guest_register.phone) {
								this.phone = data.guest_register.phone
							}
							if (data.guest_register.email) {
								this.email = data.guest_register.email
							}
							if (data.config) {
								this.course = data.config
								// countdown = data.guest_register.countdown
							}
							// if (countdown) {
							// 	countdown = new Date(countdown)
							// 	countdown.setDate(countdown.getDate() + 1)
							// 	this.course.countdown = countdown.toISOString().split('T').join(' ').replace('Z', '')
							// }

							if (['รอดูคลิปวิดีโอ', 'รอยืนยันเงื่อนไข'].includes(data.guest_register.type)) {
								this.regStep = 3
								this.videoInit()
								if (data.guest_register.type === 'รอยืนยันเงื่อนไข') {
									this.agreementAvailable = true
								}
							} else if (data.guest_register.type === 'รอเลือกคอร์ส') {
								if (data.guest_register.countdown) {
									// vue2-flip-countdown
									const countdown = new Date(data.guest_register.countdown.split(' ').join('T') + '.000Z')
									countdown.setDate(countdown.getDate() + 1)
									this.course.countdown = countdown.toISOString().split('T').join(' ').replace('.000Z', '')
								}
								this.$nextTick(() => {
									this.regStep = 4
								})
							} else if (['รอการตรวจสอบ', 'ผ่านการตรวจสอบแล้ว', 'เกินกำหนดชำระเงิน'].includes(data.guest_register.type)) {
								if (data.guest_register.countdown) {
									// vue2-flip-countdown
									const countdown = new Date(data.guest_register.countdown.split(' ').join('T') + '.000Z')
									countdown.setDate(countdown.getDate() + 1)
									this.course.countdown = countdown.toISOString().split('T').join(' ').replace('.000Z', '')
								}
								this.$nextTick(() => {
									this.regStep = 4
								})
							}
						}
					}
				}).catch(error => {
					this.alertMsg = error.message || 'พบปัญหาการตรวจสอบข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
				}).finally(() => {
					this.loading = false
				})
			}
		},

		stepGuestInfoValidation () {
			if (this.$refs.stepGuestInfo.validate()) {
				this.stepGuestInfoAlert = false
				this.stepGuestInfoMsg = ''
				this.loading = true

				// Submit info
				this.$fireFunc.httpsCallable('agent-registerInfo')({
					// fullname: this.fullname,
					name: this.name.trim(),
					lastname: this.lastname.trim(),
					nickname: this.nickname.trim(),
					province_id: this.provinceSelected.p,
					phone: this.phone.trim(),
					email: this.email.trim(),
					line: this.lineID.trim(),
					facebook: this.facebook.trim(),
					from_channel: this.from_channel === 'อื่นๆ' ? this.from_channel_other.trim() : this.from_channel,
					reference_agent_id: this.reference_agent_id.trim(),
					reference_ae_id: this.reference_ae_id.trim(),
					contact_channel: this.contact_channel.join(','),
				}).then(({data}) => {
					if (data.error) {
						this.stepGuestInfoAlert = true
						this.stepGuestInfoMsg  = data.error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
					} else {
						// if (data.guest_register) {
						// 	if (data.guest_register.type === 'รอดูคลิปวิดีโอ') {
						// 		this.regStep = 3
						// 		this.videoInit()
						// 	} else if (data.guest_register.type === 'รอยืนยันเงื่อนไข') {
						// 		this.regStep = 4
						// 	} else if (data.guest_register.type === 'รอเลือกคอร์ส') {
						// 		this.regStep = 5
						// 	} else if (['รอการตรวจสอบ', 'ผ่านการตรวจสอบแล้ว'].includes(data.guest_register.type)) {
						// 		this.regStep = 6
						// 	}
						// }
						this.regStep = 3
						this.videoInit()
					}
				}).catch(error => {
					this.stepGuestInfoAlert = true
					this.stepGuestInfoMsg = error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
				}).finally(() => {
					this.loading = false
				})
			}
		},

		stepVideoValidation () {
			if (this.videoFinished) {
				this.stepVideoAlert = false
				this.stepVideoMsg = ''
				this.loading = true

				// Submit info
				this.$fireFunc.httpsCallable('agent-registerFinishVideo')({
					phone: this.phone,
					email: this.email,
				}).then(({data}) => {
					if (data.error) {
						this.stepVideoAlert = true
						this.stepVideoMsg  = data.error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
					} else {
						this.$nextTick(() => {
							this.agreementAvailable = true
							setTimeout(() => {
								window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: 'smooth' })
							}, 500)
						})
					}
				}).catch(error => {
					this.stepVideoAlert = true
					this.stepVideoMsg = error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
				}).finally(() => {
					this.loading = false
				})
			}
		},

		stepAgreementValidation () {
			// if (this.$refs.stepAgreementForm.validate()) {
			this.stepVideoAlert = false
			this.stepVideoMsg = ''
			this.loading = true

			// Submit info
			this.$fireFunc.httpsCallable('agent-registerConfirm')({
				phone: this.phone,
				email: this.email,
			}).then(({data}) => {
				if (data.error) {
					// this.stepAgreementAlert = true
					// this.stepAgreementMsg  = data.error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
					this.stepVideoAlert = true
					this.stepVideoMsg  = data.error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
				} else {
					if (data.guest_register.countdown) {
						// vue2-flip-countdown
						this.$nextTick(() => {
							const countdown = new Date(data.guest_register.countdown.split(' ').join('T') + '.000Z')
							countdown.setDate(countdown.getDate() + 1)
							this.course.countdown = countdown.toISOString().split('T').join(' ').replace('.000Z', '')
						})
					}
					if (data.config) {
						this.course = data.config
					}
					this.$nextTick(() => {
						this.regStep = 4
						setTimeout(() => {
							this.$refs.topPage.scrollIntoView({ behavior: 'smooth', block: 'start' })
						}, 400)
					})
				}
			}).catch(error => {
				// this.stepAgreementAlert = true
				// this.stepAgreementMsg = error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
				this.stepVideoAlert = true
				this.stepVideoMsg  = error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
			}).finally(() => {
				this.loading = false
			})
			// }
		},

		courseChange (val) {
			this.stepCourseAlert = false
			this.stepCourseMsg = ''
			this.loading = true

			this.$fireFunc.httpsCallable('agent-registerCourse')({
				phone: this.phone,
				email: this.email,
				course: val
			}).then(({data}) => {
				if (data.error) {
					this.stepCourseAlert = true
					this.stepCourseMsg  = data.error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
				}
			}).catch(error => {
				this.stepCourseAlert = true
				this.stepCourseMsg  = error.message || 'พบปัญหาการส่งข้อมูล กรุณาติดต่อผู้ดูแลระบบ'
			}).finally(() => {
				this.loading = false
			})
		},

		goRegister () {
			this.regStep = 2
			setTimeout(() => {
				this.$nextTick(() => {
					window.scrollTo({ top: 0, behavior: 'smooth' })
				})
			}, 500)
		}
	},

	head() {
		return this.head(doc)
	}
}
</script>

<style lang="scss" scoped>
::v-deep .v-stepper__step.v-stepper__step--active {
	.v-stepper__step__step, .v-stepper__label {
		color: red;
	}
	.v-stepper__step__step {
		background: rgba(255, 255, 255, 0.05);
	}
}
.banner {
	background-color: #fff;
}
.bgGray { background: #3b3b3b; }
.bgDark { background: #2e2e2e; }
::v-deep .v-stepper__label {
	line-height: unset !important;
}
::v-deep .error--text {
	color: #ff5252 !important;
	caret-color: #ff5252 !important;
}
.v-alert.error {
	background-color: red;
}
.img-remove {
	z-index: 1;
	top: -5px;
	left: -5px;
}

.sta-ul {
	li {
		margin-bottom: 8px;
		align-content: center;
		list-style: none;
		min-height: 75px;
		padding-left: 75px;
		background: url('/images/sta-li.png') no-repeat left;
		background-size: 75px;
	}

	ul.icon-top {
		li {
			background-position-y: top;
		}
	}
}
.sta-privilege {
	background: url('/images/sta-privilege-bg.jpg') no-repeat;
	background-size: cover;
}
.sta-agenda-card {
	border-radius: 15px !important;
	line-height: 1.1em;
	// font-size: 1.5em;
	font-size: clamp(18px, 5vw, 24px);
	padding-left: calc(58% - 70px);

	&.closed::after, &.opened::after {
		content: "ปิดคอร์ส";
    font-size: max(0.9em, 20px);
    line-height: 1em;
    color: #fff;
    background-color: #424242;
    border-radius: 15px;
    width: 70px;
    height: 100%;
    position: absolute;
    right: 0px;
    text-align: center;
    align-content: center;
	}
	&.opened {
		b, div {
			width: calc(100% - 110px);
			text-align: center;
		}

		&::after {
			content: "เปิดคอร์ส";
			background-color: #4CAF50;
			width: 110px;
			font-size: max(1.4em, 29px);
		}
	}

	// @media screen and (max-width: 545px) {
	// 	&.closed, &.opened {
	// 		margin-left: -5%;

	// 		&::after {
	// 			right: -60px;
	// 		}
	// 	}
	// }
	// @media screen and (max-width: 495px) {
	// 	&.closed, &.opened {
	// 		margin-left: -15%;

	// 		&::after {
	// 			right: -75px;
	// 		}
	// 	}
	// }
	// @media screen and (max-width: 445px) {
	// 	&.closed, &.opened {
	// 		margin-left: -20%;

	// 		&::after {
	// 			right: -95px;
	// 		}
	// 	}
	// }
}

.agreement-detail {
	border: 1px solid #BDBDBD;
	border-radius: 5px;
	padding: 10px 20px;
	color: white;
	margin-bottom: 20px;
}

::v-deep .flip-clock__piece {
	max-width: 67px;

	.flip-card {
		font-size: 2rem;
	}
	.flip-clock__slot {
		font-size: 0.8rem;
		color: white;
	}
}
</style>
